import formatBrazilianPhone from "services/formatBrazilianPhone";
import alertWpp from '../../../assets/img/alertWpp.svg';
import React from 'react';

import { Button, IconClose } from "takeat-design-system-ui-kit";
import { WaiterAlertWppDesignContainer } from "./styles";

export default function WaiterAlertWppDesign({
  handleThrowoutHelpRequest,
  handleRedirectToWpp,
  currentWppAlert
}) {
  return <WaiterAlertWppDesignContainer>
    <header>
      <section>
        <img src={alertWpp}/>
        <span>Um cliente precisa de ajuda no whatsapp!</span>
      </section>
      <div onClick={() => handleThrowoutHelpRequest(currentWppAlert?.id)}>
        <IconClose fontSize={24}/>
      </div>
    </header>
    <footer>
      <div>
        <span>Cliente:</span>
        <span>{formatBrazilianPhone(currentWppAlert?.phone_number)}</span>
      </div>
      <Button onClick={() => handleRedirectToWpp(
        currentWppAlert?.phone_number,
        currentWppAlert?.id
      )}>Abrir conversa</Button>
    </footer>
  </WaiterAlertWppDesignContainer>
}